import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminOrganizacionesPage } from "@/features/admin-organizaciones/components/AdminOrganizacionesPage";
import { organizacionesAdminPageQueryOptions } from "@/features/admin-organizaciones/hooks/use-organizaciones-admin";

export const Route = createFileRoute("/_authed-tw/admin/organizaciones")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminOrganizaciones])
      ? queryClient.ensureQueryData(organizacionesAdminPageQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminOrganizaciones]}>
      <AdminOrganizacionesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
